import React, { useState } from 'react';
import {ArrowRight2} from 'iconsax-react';

const AccordionItem = ({ title, content }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="border-b z-[-1]">
      <div className="flex justify-between items-center bg-white rounded-lg p-5 cursor-pointer" onClick={toggleAccordion}>
        <div className="font-semibold text-sm">{title}</div>
        <div className={`transform transition-transform ${isOpen ? 'rotate-[270deg]' : 'rotate-90'}`}>
          <ArrowRight2 size={16} color="#333" />        
        </div>
      </div>
      {isOpen && <div className="p-3 text-sm">{content}</div>}
    </div>
  );
};

export const Accordion = ({content = [{}]}) => {
  return (
    <div className="max-w-md mx-auto flex flex-col gap-[10px] my-8">
      {
        content[0].title ? content.map((item) => (
          <AccordionItem title={item.title} content={item.content} />
        )) : <></>
      }
    </div>
  );
};

